<template>
  <section class="medium-g">
    <slot />
  </section>
</template>

<style scoped>
/* 中グループ同士のマージンは40pxデフォルト */
.medium-g:not(:first-child) {
  margin-top: var(--base-40px);
}

.medium-g:deep(.t-24px) {
  margin-top: var(--base-24px);
}
.medium-g:deep(.l-24px) {
  margin-left: var(--base-24px);
}
</style>
